import { render, staticRenderFns } from "./BookListItemComponent.vue?vue&type=template&id=313a070c&scoped=true&"
import script from "./BookListItemComponent.vue?vue&type=script&lang=ts&"
export * from "./BookListItemComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BookListItemComponent.vue?vue&type=style&index=0&id=313a070c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a070c",
  null
  
)

export default component.exports